// extracted by css-extract-rspack-plugin
export default {"container":"container-jlSLSe","disabled":"disabled-Optk1A"};